<template>
     <div class="chart">
    <BarChart  
      :data="dataChart"
      x-name="Respuestas"
      y-name="Cantidad"
      label-rotate
      rainbow
    />
  </div>
</template>

<script>
import {   BarChart
  //...
} from 'dr-vue-echarts';
    export default {
        name: 'BarsChartVue',
        components: {
            BarChart
        },
        props: {
            chartData: {
                type: Array,
                default: () => {
                    return [];
                }
            }
    },
        data () {
             return {
      dataChart: [
        {
          name: "Respuestas",
          data: [
            {
              label: "2018",
              value: 45
            },
            {
              label: "2019",
              value: 60
            }
          ]
        }
      ]
    };
        },
        computed: {
            
        },
        methods: {
           
        },
mounted: function() {
    this.dataChart[0].data = this.chartData;
   
  }
    };
</script>
<style>
.chart {
  width: 100%;
  height: 300px;
}
</style>
